// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.question-title {
  width: 540px;
}

.question-subtext {
  font-size: 22px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: 28px !important;
}

/* button.lr-btn-binary {
  width: 48px !important;
} */
`, "",{"version":3,"sources":["webpack://./projects/lossreporting-library/src/lib/incident-details/work-related/work-related.component.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;;GAEG","sourcesContent":[".question-title {\n  width: 540px;\n}\n\n.question-subtext {\n  font-size: 22px !important;\n  font-style: normal !important;\n  font-weight: 400 !important;\n  line-height: 28px !important;\n}\n\n/* button.lr-btn-binary {\n  width: 48px !important;\n} */\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
